import { c as _c } from "react/compiler-runtime";
import { Box, Button, Flex, IconButton, Spinner, Text } from '@chakra-ui/react';
import { LuBell } from 'react-icons/lu';
import { formatRelativeTime } from '@/components/pages/Digraph/AssistantDrawer/formatRelativeTime';
import { PopoverBody, PopoverContent, PopoverHeader, PopoverRoot, PopoverTrigger } from '@/components/ui/popover';
import { Tooltip } from '@/components/ui/tooltip';
import { InboxNotificationWire } from '@/server/routers/notification';
const MAX_BADGE_COUNT = 9;
type NotificationBellProps = {
  unreadCount: number;
  notifications: InboxNotificationWire[];
  isLoading: boolean;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onOpenNotification: (notification: InboxNotificationWire) => void;
  onMarkAllRead: () => void;
};
const NotificationBell = t0 => {
  const $ = _c(31);
  const {
    unreadCount,
    notifications,
    isLoading,
    open,
    onOpenChange,
    onOpenNotification,
    onMarkAllRead
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      placement: "bottom-end"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== onOpenChange) {
    t2 = event => onOpenChange(event.open);
    $[1] = onOpenChange;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const t3 = unreadCount > 0 ? `Notifications (${unreadCount} unread)` : "Notifications";
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <LuBell size={18} />;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== t3) {
    t5 = <Tooltip content="Notifications" openDelay={200}><IconButton aria-label={t3} data-testid="notification-bell" size="sm" variant="ghost">{t4}</IconButton></Tooltip>;
    $[4] = t3;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== unreadCount) {
    t6 = unreadCount > 0 && <Box bg="red.500" borderRadius="full" color="white" data-testid="notification-unread-badge" fontSize="2xs" fontWeight="bold" lineHeight="14px" minWidth="14px" pointerEvents="none" position="absolute" px="2px" right="2px" textAlign="center" top="2px">{unreadCount > MAX_BADGE_COUNT ? `${MAX_BADGE_COUNT}+` : unreadCount}</Box>;
    $[6] = unreadCount;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== t5 || $[9] !== t6) {
    t7 = <PopoverTrigger asChild={true}><Box display="inline-block" position="relative">{t5}{t6}</Box></PopoverTrigger>;
    $[8] = t5;
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <Text fontSize="sm" fontWeight="semibold">Notifications</Text>;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== onMarkAllRead || $[13] !== unreadCount) {
    t9 = unreadCount > 0 && <Button size="xs" variant="ghost" onClick={onMarkAllRead}>Mark all read</Button>;
    $[12] = onMarkAllRead;
    $[13] = unreadCount;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== t9) {
    t10 = <PopoverHeader><Flex alignItems="center" justifyContent="space-between">{t8}{t9}</Flex></PopoverHeader>;
    $[15] = t9;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== isLoading || $[18] !== notifications || $[19] !== onOpenNotification) {
    t11 = isLoading ? <Flex justifyContent="center" py={6}><Spinner size="sm" /></Flex> : notifications.length === 0 ? <Text color="gray.500" fontSize="sm" px={4} py={6} textAlign="center">No notifications yet. You'll be notified about activity on issues you follow.</Text> : notifications.map(notification => <Box key={notification.id} _hover={{
      bg: "gray.50"
    }} borderBottomColor="gray.100" borderBottomWidth="1px" cursor="pointer" data-testid="notification-item" px={4} py={2.5} onClick={() => onOpenNotification(notification)}><Flex alignItems="baseline" gap={2}>{!notification.readAt && <Box bg="blue.500" borderRadius="full" flexShrink={0} height="8px" width="8px" />}<Box minW={0}><Text fontSize="sm" fontWeight={notification.readAt ? "normal" : "semibold"}>{notification.title}</Text>{notification.snippet && <Text color="gray.600" fontSize="xs" lineClamp={2}>{notification.snippet}</Text>}<Text color="gray.400" fontSize="xs">{formatRelativeTime(new Date(notification.createdAt))}</Text></Box></Flex></Box>);
    $[17] = isLoading;
    $[18] = notifications;
    $[19] = onOpenNotification;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== t11) {
    t12 = <PopoverBody p={0}>{t11}</PopoverBody>;
    $[21] = t11;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  let t13;
  if ($[23] !== t10 || $[24] !== t12) {
    t13 = <PopoverContent maxHeight="420px" overflowY="auto" width="360px">{t10}{t12}</PopoverContent>;
    $[23] = t10;
    $[24] = t12;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  let t14;
  if ($[26] !== open || $[27] !== t13 || $[28] !== t2 || $[29] !== t7) {
    t14 = <PopoverRoot open={open} positioning={t1} onOpenChange={t2}>{t7}{t13}</PopoverRoot>;
    $[26] = open;
    $[27] = t13;
    $[28] = t2;
    $[29] = t7;
    $[30] = t14;
  } else {
    t14 = $[30];
  }
  return t14;
};
export default NotificationBell;